'use client';

import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import CinemaPickerDropdown from '@/components/CinemaPickerDropdown';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';

import { cn } from '@cineamo/ui/src/helpers/cn';

import useClickOutside from '@cineamo/ui/src/hooks/useClickOutside';

import { IconDown16 } from '@cineamo/ui/src/icons/ic-down';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type DemoDomainToolsProps = {
    onChangeCinema: (cinema: CinemaDto) => Promise<void>;
};

const DemoDomainTools: React.FC<DemoDomainToolsProps> = ({ onChangeCinema }) => {
    const t = useTranslations();
    const [isDemoDomainToolsExpanded, setIsDemoDomainToolsExpanded] = useState<boolean>(false);
    const [isCinemaPickerDropdownOpen, setIsCinemaPickerDropdownOpen] = useState<boolean>(false);
    const { ref } = useClickOutside(() => setIsCinemaPickerDropdownOpen(false));
    const { ref: demoDomainToolsRef } = useClickOutside(() => setIsDemoDomainToolsExpanded(false));
    const domainConfiguration = useDomainConfiguration();
    return (
        <div
            className={cn(
                'fixed left-0 right-0 top-0 max-w-full mx-auto z-[1010]',
                'duration-150',
                isDemoDomainToolsExpanded ? 'w-[400px]' : 'w-[100px]'
            )}
            ref={demoDomainToolsRef}>
            <div className="flex flex-col bg-red/20 backdrop-blur rounded-b-8">
                <div
                    className={cn(
                        '',
                        'duration-150',
                        isDemoDomainToolsExpanded ? 'p-[16px]' : 'max-h-[8px] opacity-0'
                    )}>
                    <span
                        className="text-body-bold-14 clickable-element"
                        onClick={() => setIsCinemaPickerDropdownOpen(true)}>
                        {t('demo.cinema-picker.choose-cinema')}
                    </span>
                    <div ref={ref}>
                        <CinemaPickerDropdown
                            open={isCinemaPickerDropdownOpen}
                            setOpen={setIsCinemaPickerDropdownOpen}
                            currentCinema={domainConfiguration.cinema}
                            selectCinemaHandler={async (cinema) => {
                                onChangeCinema(cinema);
                            }}
                        />
                    </div>
                </div>
                <IconDown16
                    className={cn('self-center duration-150 clickable-element p-[4px] box-content', {
                        'rotate-180': !isDemoDomainToolsExpanded
                    })}
                    onClick={() => setIsDemoDomainToolsExpanded(!isDemoDomainToolsExpanded)}
                />
            </div>
        </div>
    );
};

export default DemoDomainTools;
